import type { InputHTMLAttributes } from 'react';

import { Icon } from '@/shared/ui/atoms/Icon';
import './SearchBox.styl';

type Props = InputHTMLAttributes<HTMLInputElement>;

export function SearchBox({ className, ...rest }: Props) {
  return (
    <label className={className ? `m-search ${className}` : 'm-search'}>
      <Icon name="search" size={15} strokeWidth={1.6} className="m-search__icon" />
      <input type="search" className="m-search__input" {...rest} />
    </label>
  );
}
